// Classes
import BaseService from './base-service';

// Constants
import { API_BASE_PATH } from 'libs/utils/constants';

/**
 * @const {number} MAX_MEETINGS_PER_PAGE the maximum number of items to load per page
 * @private
 */
const MAX_MEETINGS_PER_PAGE = 25;

/**
 * Meeting request participant invite url API endpoint
 * @constant {string} MEETING_REQUEST_PARTICIPANT_INVITE_URL_API_ENDPOINT
 * @private
 */
const MEETING_REQUEST_PARTICIPANT_INVITE_URL_API_ENDPOINT =
    `${API_BASE_PATH}/events/{{eventId}}/meeting-request/{{meetingRequestId}}/participant/{{participantId}}/inviteUrl`;

/**
 * @constant {string}
 * @private
 */
const MEETING_REQUEST_REPRESENTATIVE_BLOCKED_SLOTS_API_ENDPOINT =
    `${API_BASE_PATH}/events/{{eventId}}/meeting-request/{{meetingRequestId}}/representative/blocked-slots`;


/**
 * @constant {string}
 * @private
 */
const MEETING_REQUEST_OVERALL_AVAILABILITY_ENDPOINT =
    `${API_BASE_PATH}/eid/{{eventId}}/overall-availability-emails`;

export default class MeetingsService extends BaseService {

    get MAX_MEETINGS_PER_PAGE() {
        return MAX_MEETINGS_PER_PAGE;
    }

    /**
     * Get all meetings.
     *
     * TEMPORARY: This method is a temporary workaround to call the app script directly.
     *
     * @param {string} eventId
     * @param {object} services
     * @param {object} params
     *
     * @returns {Promise<object>}
     */
    async getAll(eventId, services, params) {
        const { crudOpts, page, sortField, sort, search } = params;
        const { rows, total_rows } = await services.appScripts.callAppScript(eventId, crudOpts.appscriptUrl, {
            skip: (page - 1) * this.MAX_MEETINGS_PER_PAGE,
            reverse: sort !== 'ASC',
            sort: sortField,
            search,
            limit: this.MAX_MEETINGS_PER_PAGE
        });

        return { rows, total: total_rows };
    }

    /**
     * Get participant invite url for a meeting request
     *
     * @param {string} eventId
     * @param {string} meetingRequestId
     * @param {string} participantId
     * @returns {Promise<{inviteUrl: string}>}
     */
    async getMeetingRequestParticipantInviteUrl(eventId, meetingRequestId, participantId) {
        const url = this.buildUrl(MEETING_REQUEST_PARTICIPANT_INVITE_URL_API_ENDPOINT, { eventId, meetingRequestId, participantId });
        const { data } = await this.get(url);

        return data;
    }

    /**
     * Get meeting request representative/organizer busy slots - ie. previously booked meetings.
     *
     * @param {string} eventId
     * @param {string} meetingRequestId
     * @returns {Promise<{ blockedSlots: TimeSlot[] }>}
     */
    async getRepresentativeBlockedSlots(eventId, meetingRequestId) {
        const url = this.buildUrl(MEETING_REQUEST_REPRESENTATIVE_BLOCKED_SLOTS_API_ENDPOINT, { eventId, meetingRequestId });
        const { data } = await this.get(url);

        return data;
    }

    /**
     * @param {string} eventId
     * @param {string[]} participantIds
     */
    async sendOverallAvailabilityEmails(eventId, participantIds) {
        const url = this.buildUrl(MEETING_REQUEST_OVERALL_AVAILABILITY_ENDPOINT, { eventId });
        const { data } = this.post(url, { participantIds });
        return data;
    }
}
